import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home/Home';
import News from './pages/News/News';
import Explore from './pages/Explore/Explore';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Profile from './pages/Profile/Profile';
import SinglePost from './pages/SinglePost/SinglePost';
import SharedPost from './pages/SharedPost/SharedPost';
import ContactUs from './pages/ContactUs/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ChildSafety from './pages/ChildSafety/ChildSafety';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import Reports from './pages/Reports/Reports';
import DeleteAccount from './pages/DeleteAccount/DeleteAccount';
import SingleReport from './pages/SingleReport/SingleReport';
import QRReport from './pages/QRReport/QRReport';
import FactOMeter from './pages/FactOMeter/FactOMeter';
import { usePageViewBeacon } from './utils/beacon';

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

// Anonymous page-view beacon — feeds web_page_views / web_unique_visitors in
// the admin analytics tab. Reports the route on load and on every navigation.
const PageViewBeacon = () => {
	usePageViewBeacon(useLocation().pathname);
	return null;
};

function App() {
	return (
		<div className='App'>
			<ScrollToTop />
			<PageViewBeacon />
			<Routes>
				<Route path='/' element={<Home />} />
				<Route path='/news' element={<News />} />
				<Route path='/explore' element={<Explore />} />
				<Route path='/reports' element={<Reports />} />
				<Route path='/fact-o-meter' element={<FactOMeter />} />
				<Route path='/login' element={<Login />} />
				<Route path='/signup' element={<Signup />} />
				<Route path='/profile' element={<Profile />} />
				<Route path='/getpost/:postId' element={<SinglePost />} />
				{/* Signed share link: /share/<id>/<hash>. Logged-in viewers get
				    redirected to /getpost/<id>; logged-out viewers see read-only. */}
				<Route path='/share/:id/:hash' element={<SharedPost />} />
				<Route path='/getreport/:reportId' element={<SingleReport />} />
				<Route path='/contact' element={<ContactUs />} />
				<Route path='/policy' element={<PrivacyPolicy />} />
				<Route path='/child-safety' element={<ChildSafety />} />
				<Route path='/admin' element={<AdminPanel />} />
				<Route path='/deleteAccount' element={<DeleteAccount />} />
				<Route path='/qr-report/org/:orgName' element={<QRReport />} />
				{/* Department-specific QR: the authority is pre-selected by name. */}
				<Route path='/qr-report/org/:orgName/:authorityName' element={<QRReport />} />
			</Routes>
		</div>
	);
}

export default App;
